import React, { FC } from 'react';
import { classNameProp } from '@monorepo/type';
import styles from './index.module.css';

const EllipsisText: FC<classNameProp> = ({ children, className = '' }) => (
  <span className={`${styles.ellipsis} ${className}`}>{children}</span>
);

export default EllipsisText; // todo add this wrap to ChosenFilters after FCP-178 merge
